const Spinner = () => {
  return (
    <div className="relative">
      <div className="w-14 h-14 spinner border-[6px] border-y-amber-500 dark:border-b-orange-300 dark:border-purple-700 shadow-lg dark:shadow-orange-300/50"></div>
    </div>
  );
};

export default Spinner;
